export default __webpack_public_path__ + "static/media/doc3.a0b8272a.jpg";